import React from 'react';
import { Box, Heading, Text, Button, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const Success: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Flex justifyContent="center" alignItems="center" height="100vh" bg="gray.50">
      <Box
        textAlign="center"
        p={6}
        borderWidth={1}
        borderRadius="lg"
        bg="white"
        shadow="md"
      >
        <Heading as="h2" size="xl" mb={4} color="green.500">
          ¡Pago Exitoso!
        </Heading>
        <Text fontSize="lg" mb={6}>
          Tu pago se ha procesado correctamente. Gracias por utilizar nuestro portal ciudadano.
        </Text>
        <Button
          colorScheme="teal"
          size="lg"
          onClick={() => navigate('/portal')}
        >
          Volver al Inicio
        </Button>
      </Box>
    </Flex>
  );
};

export default Success;
